import { render, staticRenderFns } from "./PatientWelcomeDisplay.vue?vue&type=template&id=470980bb&scoped=true"
import script from "./PatientWelcomeDisplay.vue?vue&type=script&lang=js"
export * from "./PatientWelcomeDisplay.vue?vue&type=script&lang=js"
import style0 from "./PatientWelcomeDisplay.vue?vue&type=style&index=0&id=470980bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470980bb",
  null
  
)

export default component.exports